import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  UpdateTrashBinAggregateBusinessRequest,
  UpdateTrashBinAggregateBusinessSuccessResponseInfo,
} from '@/coreInfrastructureModule/axios/generated/trashBinManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';

/**
 * UpdateTrashBinAggregateBusinessUseCase
 */
export class UpdateTrashBinAggregateBusinessUseCase {
  /**
   * ゴミ箱内の集計情報のフラグを操作するUseCase
   * @param repository - ゴミ箱のリポジトリ
   * @param trashBinAggregateBusinessIdArray - 更新する集計情報のID一覧
   * @param isTrashFlag - 変更するフラグ
   */
  static async Execute(
    repository: ITrashBinRepository,
    trashBinAggregateBusinessIdArray: Array<string>,
    isTrashFlag: boolean
  ): Promise<INetworkResult<UpdateTrashBinAggregateBusinessSuccessResponseInfo, IError>> {
    const request: UpdateTrashBinAggregateBusinessRequest = {
      updateTrashBinAggregateBusinessIdArray: trashBinAggregateBusinessIdArray,
      isTrashFlag: isTrashFlag,
    };
    const networkResult = await repository.updateTrashBinAggregateBusiness(request);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data,
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
